import { normalizeLocale } from '@/utils/locale';
// 判断当前环境是否可以安全使用 localStorage
export function canUseLocalStorage(): boolean {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    const testKey = '__test__';
    window.localStorage.setItem(testKey, '1');
    window.localStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

// 安全的 localStorage get 方法
export function getLocalStorageItem(key: string): string | null {
  if (!canUseLocalStorage()) return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

// 安全的 localStorage set 方法
export function setLocalStorageItem(key: string, value: string): void {
  if (!canUseLocalStorage()) return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

// 安全的 localStorage remove 方法
export function removeLocalStorageItem(key: string): void {
  if (!canUseLocalStorage()) return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

/** 获取缓存中的语言 */
export const getLocalLanguage = () => {
  return normalizeLocale(getLocalStorageItem('language') || '');
};

/** 设置语言 */
export const setLocalLanguage = (language: string) => {
  setLocalStorageItem('language', normalizeLocale(language));
};

